// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "desejo-70e83.firebaseapp.com",
  "projectId": "desejo-70e83",
  "storageBucket": "desejo-70e83.appspot.com",
  "messagingSenderId": "161118484048",
  "appId": "1:161118484048:web:a9e6337f2ecd896e238355",
  "measurementId": "G-GH65NWQFWL",
  "apiKey": "AIzaSyCm1lnq4ZsXGwf5p7fewQq1TjBJjQ3mxX8"
};
